import { useState, useEffect, Dispatch, SetStateAction } from 'react';
import { findSimilarJobs, IJob, ISimilarJobsJobSearchQuery } from 'wisestep-api';

import { similarJobsDefaultQueryJobSearch } from '../JObSearchFilterDefaultQuery';

const useSimilarJobsFromJobSearch = (
  job: IJob,
  setLoader: Dispatch<SetStateAction<boolean>>
): IJob[] => {
  const [similarJobsData, setSimilarJobsData] = useState<IJob[]>([]);
  useEffect(() => {
    const query: ISimilarJobsJobSearchQuery = similarJobsDefaultQueryJobSearch(job);
    const fetchJobs = async () => {
      try {
        setLoader(true);
        const response = await findSimilarJobs(query);
        setSimilarJobsData(response.data);
        setLoader(false);
      } catch (e) {
        setLoader(false);
      }
    };

    fetchJobs();
  }, [job, setLoader]);

  return similarJobsData;
};

export default useSimilarJobsFromJobSearch;
